import React from "react";
import { useSelector } from "react-redux";
import Dashboard from "./Dashboard";
import TransactionsViewer from "./transactions";
import Alarms from "./Alarms";

function getPageForRoute(key: string) {
    const selected = {
        dashboard: <Dashboard />,
        transactions: <TransactionsViewer/>,
        alarms: <Alarms/>,
    }[key];

    if (selected) {
        return selected;
    }
    
    return <Dashboard />;
}

function getKeyFromPath(path: string) {
    const contentKey = 3;
    const key = path.split("/")[contentKey];
    return key;
}

const MonitoringIndex = () => {
    const page = useSelector((state: any) => state.router.location.pathname);

    return getPageForRoute(getKeyFromPath(page));
};

export default MonitoringIndex;
